'use client';

//TODO: Sort remote faqs based on order index after order index implement on backend
import * as React from 'react';
import FAQAccordion, { FAQAccordionProps } from '../shared/FAQAccordion';
import Link from 'next/link';
import useSWR from 'swr';
import { getVendorFAQs } from '@/clients/customer/pages-data';
import { SectionHeader } from '@ui/Typography';
import { APP_BRAND_NAME } from '@/constant/configs';

const faqs = [
  {
    id: 1,
    question: {
      de: 'Wie hoch sind die Gebühren?',
      en: 'How high are the fees?',
    },
    answer: {
      de: 'Wähle das Abo-Paket aus, das am besten zur dir passt. Neben einem fixen Monatsbeitrag und einer einmaligen Einrichtungsgebühr inkl. Werbepaket fallen KEINE weiteren Gebühren und Kosten wie z.B. Umsatzbeteiligung (wie bei anderen Bestellsystemen) an - und werden auch nicht in Zukunft anfallen!',
      en: 'Choose the subscription package that suits you best. In addition to a fixed monthly fee and a one-time setup fee incl. an advertising package, there are NO further fees and costs such as sale shares (as with other ordering systems) - and will not be incurred in the future!',
    },
  },
  {
    id: 2,
    question: {
      de: 'Gibt es versteckte Kosten?',
      en: 'Are there any hidden costs?',
    },
    answer: {
      de: 'Nein, wir sind für dich immer 100% transparent. Alle Kosten werden offen kommuniziert. Es können aber zusätzliche externe Kosten entstehen, die du sicher auch aus deinem Geschäft kennst. Zum Beispiel gibt es Kreditkarten- oder PayPal Transaktionsgebühren. Diese laufen nicht über uns. Wir nehmen keine Zahlungen deiner Kunden entgegen. Du hast also die volle und alleinige Kontrolle!',
      en: "No, we are always 100% transparent for you. All costs are communicated openly. However, additional external costs may arise, which you are probably familiar with from your business. For example, there are credit card or PayPal transaction fees. These don't run through us. We do not accept payments from your customers. So you have full and sole control!",
    },
  },
  {
    id: 3,
    question: {
      de: `Wie lange muss ich warten, bis ich das Geld bekomme, das ich über ${APP_BRAND_NAME} verdient habe?`,
      en: `How long do I have to wait until I receive the money from ${APP_BRAND_NAME}?`,
    },
    answer: {
      de: `Du erhältst bei uns dein verdientes Geld ohne Umwege direkt auf deinem PayPal-/Kreditkartenkonto oder Bar vom Kunden ausgezahlt. Dies hängt davon ab, welche Zahlungsmethode dein Kunde gewählt hat. Außerdem hast du Zugriff auf deine Kunden, Bestellungen und deinen Umsatz direkt auf ${APP_BRAND_NAME} und kannst diese jederzeit einsehen.`,
      en: `You will receive the money you earn directly to your PayPal/credit card account or in cash from the customer. This depends on which payment method your customer has chosen. You also have access to your customers, orders and sales directly on ${APP_BRAND_NAME} and can view them at any time.`,
    },
  },
];

const getFaq = (lang: string) => {
  return faqs.map((item: any) => {
    return {
      ...item,
      question: item.question[lang],
      answer: item.answer[lang],
    };
  });
};

const fetchRemoteData = async () => {
  let filters: any = {};
  const params = window.location.search.substring(1);

  const urlParams = new URLSearchParams(params);
  if (urlParams.size > 0) {
    filters = Object.fromEntries(urlParams);
  }
  return getVendorFAQs(filters).then((res) => res.data);
};

type Props = {
  params: any;
  dictionary: any;
};

const VendorFAQList = ({ params, dictionary }: Props) => {
  const { data: fetchedData, isValidating } = useSWR(
    ['/faq'],
    fetchRemoteData,
    {
      revalidateIfStale: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const [lang] = params.locale.split('-');

  let faqList = getFaq(lang);

  if (!isValidating && fetchedData?.data?.data > 0) {
    faqList = fetchedData?.data;
  }

  return (
    <section
      id="faq"
      className="faq-section container w-full space-y-16 py-10 md:py-20 lg:py-28"
    >
      <div className="section-header flex flex-col items-center justify-center space-y-2">
        <SectionHeader>FAQ</SectionHeader>
        {/* <h3 className="text-center text-h1 font-[900] text-title">FAQ</h3> */}
      </div>
      <div className="flex items-center justify-center">
        <div className="flex w-[90%] items-center justify-center lg:w-[70%] xl:w-[60%] xl:max-w-[675px]">
          <div id="store-faqs" className="faq-list w-full space-y-3">
            {isValidating ? (
              <>
                <div className="flex w-full animate-pulse items-center justify-between rounded-[10px] border border-gray-200 bg-gray-200 p-7"></div>
                <div className="flex w-full animate-pulse items-center justify-between rounded-[10px] border border-gray-200 bg-gray-200 p-7"></div>
              </>
            ) : (
              faqList?.map((faq: FAQAccordionProps) => {
                return (
                  <FAQAccordion
                    key={faq.id}
                    id={faq.id}
                    question={faq.question}
                    answer={faq.answer}
                  />
                );
              })
            )}
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center">
        <Link
          href={
            lang === 'en'
              ? 'https://blog.lentho.com/3142-2/'
              : 'https://blog.lentho.com/faqs/'
          }
          target="_blank"
          className="rounded-[40px] bg-gradient-to-r from-[#F5375C] to-[#C33076] px-[50px] py-[26px] text-white transition-all duration-200 hover:opacity-80"
        >
          {/* Mehr erfahren */}
          {dictionary.common.see_more}
        </Link>
      </div>
    </section>
  );
};

export default VendorFAQList;
